import React, { Component } from "react";
import PropTypes from "prop-types";
import MaterialTitlePanel from "./material_title_panel";
import * as singleSpa from "single-spa";
import { registerLexonApp } from "./lexonconn-app";

const styles = {
  sidebar: {
    width: 319,
    height: "calc(100% - 5px)"
  },
  sidebarLink: {
    display: "block",
    padding: "16px 0px",
    color: "#757575",
    textDecoration: "none"
  },
  divider: {
    margin: "8px 0",
    height: 1,
    backgroundColor: "#757575"
  },
  content: {
    padding: 0,
    height: "calc(100% - 67px)",
    backgroundColor: "#fff",
    overflowY: "hidden"
  }
};

export class LexonComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      style: styles.sidebar,
      isFrame: false,
    };
  }

  componentDidMount() {
    const mountLexonApp = () => {
      try {
        const status = singleSpa.getAppStatus('lexon-app');
        if (status === 'MOUNTED') {
          singleSpa.unloadApplication('lexon-app', false);
          singleSpa.start();
        } else {
          registerLexonApp();
          singleSpa.start();
        }
      } catch (error) {
        singleSpa.unloadApplication('lexon-app', false);
        console.error(error);
      }
    };
    mountLexonApp();
  }

  render() {
    const { sidebarDocked } = this.props;
    const { style, isFrame } = this.state;

    return (
      <>
        {!isFrame &&
          <MaterialTitlePanel
            title="LexON"
            style={style}
            sidebarDocked={sidebarDocked}
          >
            <div style={styles.content}>
              <div
                id="lexon-app"
                style={{
                  height: '100%',
                  visibility: sidebarDocked ? "visible" : "hidden"
                }}>
              </div>
            </div>
          </MaterialTitlePanel>
        }
      </>
    );
  }
}

LexonComponent.propTypes = {
  style: PropTypes.object
};

export default LexonComponent;
